import type {
  APIReportFilters,
  APISearchResponse,
  GraphlakeSnapshotId,
  ReportColumn,
} from '@ardoq/api-types';
import {
  isArdoqError,
  type ArdoqError,
  type Maybe,
  type Result,
} from '@ardoq/common-helpers';
import {
  searchResultsOperations,
  type EnhancedSearchResponse,
  type ReportPagination,
} from '@ardoq/report-reader';

export type SearchResult = {
  apiError: Maybe<ArdoqError>;
  searchResults: Maybe<
    EnhancedSearchResponse & {
      snapshot: GraphlakeSnapshotId | null;
      pagination: ReportPagination;
    }
  >;
  filterableColumns: ReportColumn[];
  filters: Maybe<APIReportFilters>;
};

type SearchResponse = {
  searchResults: Result<APISearchResponse>;
  snapshot: GraphlakeSnapshotId | null;
  pagination: ReportPagination;
};

export const mapSearchResults = ({
  searchResults,
  snapshot,
  pagination,
}: SearchResponse): SearchResult => {
  if (isArdoqError(searchResults)) {
    return {
      apiError: searchResults,
      searchResults: null,
      filterableColumns: [],
      filters: null,
    };
  }
  const searchResultsWithDateRangeFields =
    searchResultsOperations.mergeDateRangeFieldsAndEnhanceScopeData(
      searchResults
    );

  const filterableColumns = searchResultsOperations.getFilterableColumns(
    searchResultsWithDateRangeFields
  );

  return {
    apiError: null,
    searchResults: {
      ...searchResultsWithDateRangeFields,
      snapshot,
      pagination,
    },
    filterableColumns,
    filters: searchResults.filters ?? null,
  };
};
